export default {
    countries: [
        { value: "AF", label: "Afghanistan" },
        { value: "AX", label: "Aland Islands" },
        { value: "AL", label: "Albania" },
        { value: "DZ", label: "Algeria" },
        { value: "AS", label: "American Samoa" },
        { value: "AD", label: "Andorra" },
        { value: "AO", label: "Angola" },
        { value: "AI", label: "Anguilla" },
        { value: "AQ", label: "Antarctica" },
        { value: "AG", label: "Antigua and Barbuda" },
        { value: "AR", label: "Argentina" },
        { value: "AM", label: "Armenia" },
        { value: "AW", label: "Aruba" },
        { value: "AU", label: "Australia" },
        { value: "AT", label: "Austria" },
        { value: "AZ", label: "Azerbaijan" },
        { value: "BS", label: "Bahamas" },
        { value: "BH", label: "Bahrain" },
        { value: "BD", label: "Bangladesh" },
        { value: "BB", label: "Barbados" },
        { value: "BY", label: "Belarus" },
        { value: "BE", label: "Belgium" },
        { value: "BZ", label: "Belize" },
        { value: "BJ", label: "Benin" },
        { value: "BM", label: "Bermuda" },
        { value: "BT", label: "Bhutan" },
        { value: "BO", label: "Bolivia" },
        { value: "BA", label: "Bosnia and Herzegovina" },
        { value: "BW", label: "Botswana" },
        { value: "BV", label: "Bouvet Island (Bouvetoya)" },
        { value: "BR", label: "Brazil" },
        { value: "IO", label: "British Indian Ocean Territory (Chagos Archipelago)" },
        { value: "VG", label: "British Virgin Islands" },
        { value: "BN", label: "Brunei Darussalam" },
        { value: "BG", label: "Bulgaria" },
        { value: "BF", label: "Burkina Faso" },
        { value: "BI", label: "Burundi" },
        { value: "KH", label: "Cambodia" },
        { value: "CM", label: "Cameroon" },
        { value: "CA", label: "Canada" },
        { value: "CV", label: "Cape Verde" },
        { value: "KY", label: "Cayman Islands" },
        { value: "CF", label: "Central African Republic" },
        { value: "TD", label: "Chad" },
        { value: "CL", label: "Chile" },
        { value: "CN", label: "China" },
        { value: "CX", label: "Christmas Island" },
        { value: "CC", label: "Cocos (Keeling) Islands" },
        { value: "CO", label: "Colombia" },
        { value: "KM", label: "Comoros" },
        { value: "CD", label: "Democratic Republic of the Congo" },
        { value: "CG", label: "Congo" },
        { value: "CK", label: "Cook Islands" },
        { value: "CR", label: "Costa Rica" },
        { value: "CI", label: "Cote d'Ivoire" },
        { value: "HR", label: "Croatia" },
        { value: "CU", label: "Cuba" },
        { value: "CY", label: "Cyprus" },
        { value: "CZ", label: "Czech Republic" },
        { value: "DK", label: "Denmark" },
        { value: "DJ", label: "Djibouti" },
        { value: "DM", label: "Dominica" },
        { value: "DO", label: "Dominican Republic" },
        { value: "EC", label: "Ecuador" },
        { value: "EG", label: "Egypt" },
        { value: "SV", label: "El Salvador" },
        { value: "GQ", label: "Equatorial Guinea" },
        { value: "ER", label: "Eritrea" },
        { value: "EE", label: "Estonia" },
        { value: "ET", label: "Ethiopia" },
        { value: "FO", label: "Faroe Islands" },
        { value: "FK", label: "Falkland Islands (Malvinas)" },
        { value: "FJ", label: "Fiji" },
        { value: "FI", label: "Finland" },
        { value: "FR", label: "France" },
        { value: "GF", label: "French Guiana" },
        { value: "PF", label: "French Polynesia" },
        { value: "TF", label: "French Southern Territories" },
        { value: "GA", label: "Gabon" },
        { value: "GM", label: "Gambia" },
        { value: "GE", label: "Georgia" },
        { value: "DE", label: "Germany" },
        { value: "GH", label: "Ghana" },
        { value: "GI", label: "Gibraltar" },
        { value: "GR", label: "Greece" },
        { value: "GL", label: "Greenland" },
        { value: "GD", label: "Grenada" },
        { value: "GP", label: "Guadeloupe" },
        { value: "GU", label: "Guam" },
        { value: "GT", label: "Guatemala" },
        { value: "GG", label: "Guernsey" },
        { value: "GN", label: "Guinea" },
        { value: "GW", label: "Guinea-Bissau" },
        { value: "GY", label: "Guyana" },
        { value: "HT", label: "Haiti" },
        { value: "HM", label: "Heard Island and McDonald Islands" },
        { value: "VA", label: "Holy See (Vatican City State)" },
        { value: "HN", label: "Honduras" },
        { value: "HK", label: "Hong Kong" },
        { value: "HU", label: "Hungary" },
        { value: "IS", label: "Iceland" },
        { value: "IN", label: "India" },
        { value: "ID", label: "Indonesia" },
        { value: "IR", label: "Iran" },
        { value: "IQ", label: "Iraq" },
        { value: "IE", label: "Ireland" },
        { value: "IM", label: "Isle of Man" },
        { value: "IL", label: "Israel" },
        { value: "IT", label: "Italy" },
        { value: "JM", label: "Jamaica" },
        { value: "JP", label: "Japan" },
        { value: "JE", label: "Jersey" },
        { value: "JO", label: "Jordan" },
        { value: "KZ", label: "Kazakhstan" },
        { value: "KE", label: "Kenya" },
        { value: "KI", label: "Kiribati" },
        { value: "KP", label: "Korea" },
        { value: "KR", label: "Korea" },
        { value: "KW", label: "Kuwait" },
        { value: "KG", label: "Kyrgyz Republic" },
        { value: "LA", label: "Lao" },
        { value: "LV", label: "Latvia" },
        { value: "LB", label: "Lebanon" },
        { value: "LS", label: "Lesotho" },
        { value: "LR", label: "Liberia" },
        { value: "LY", label: "Libyan Arab Jamahiriya" },
        { value: "LI", label: "Liechtenstein" },
        { value: "LT", label: "Lithuania" },
        { value: "LU", label: "Luxembourg" },
        { value: "MO", label: "Macao" },
        { value: "MK", label: "Macedonia" },
        { value: "MG", label: "Madagascar" },
        { value: "MW", label: "Malawi" },
        { value: "MY", label: "Malaysia" },
        { value: "MV", label: "Maldives" },
        { value: "ML", label: "Mali" },
        { value: "MT", label: "Malta" },
        { value: "MH", label: "Marshall Islands" },
        { value: "MQ", label: "Martinique" },
        { value: "MR", label: "Mauritania" },
        { value: "MU", label: "Mauritius" },
        { value: "YT", label: "Mayotte" },
        { value: "MX", label: "Mexico" },
        { value: "FM", label: "Micronesia" },
        { value: "MD", label: "Moldova" },
        { value: "MC", label: "Monaco" },
        { value: "MN", label: "Mongolia" },
        { value: "ME", label: "Montenegro" },
        { value: "MS", label: "Montserrat" },
        { value: "MA", label: "Morocco" },
        { value: "MZ", label: "Mozambique" },
        { value: "MM", label: "Myanmar" },
        { value: "NA", label: "Namibia" },
        { value: "NR", label: "Nauru" },
        { value: "NP", label: "Nepal" },
        { value: "AN", label: "Netherlands Antilles" },
        { value: "NL", label: "Netherlands" },
        { value: "NC", label: "New Caledonia" },
        { value: "NZ", label: "New Zealand" },
        { value: "NI", label: "Nicaragua" },
        { value: "NE", label: "Niger" },
        { value: "NG", label: "Nigeria" },
        { value: "NU", label: "Niue" },
        { value: "NF", label: "Norfolk Island" },
        { value: "MP", label: "Northern Mariana Islands" },
        { value: "NO", label: "Norway" },
        { value: "OM", label: "Oman" },
        { value: "PK", label: "Pakistan" },
        { value: "PW", label: "Palau" },
        { value: "PS", label: "Palestinian Territory" },
        { value: "PA", label: "Panama" },
        { value: "PG", label: "Papua New Guinea" },
        { value: "PY", label: "Paraguay" },
        { value: "PE", label: "Peru" },
        { value: "PH", label: "Philippines" },
        { value: "PN", label: "Pitcairn Islands" },
        { value: "PL", label: "Poland" },
        { value: "PT", label: "Portugal" },
        { value: "PR", label: "Puerto Rico" },
        { value: "QA", label: "Qatar" },
        { value: "RE", label: "Reunion" },
        { value: "RO", label: "Romania" },
        { value: "RU", label: "Russian Federation" },
        { value: "RW", label: "Rwanda" },
        { value: "BL", label: "Saint Barthelemy" },
        { value: "SH", label: "Saint Helena" },
        { value: "KN", label: "Saint Kitts and Nevis" },
        { value: "LC", label: "Saint Lucia" },
        { value: "MF", label: "Saint Martin" },
        { value: "PM", label: "Saint Pierre and Miquelon" },
        { value: "VC", label: "Saint Vincent and the Grenadines" },
        { value: "WS", label: "Samoa" },
        { value: "SM", label: "San Marino" },
        { value: "ST", label: "Sao Tome and Principe" },
        { value: "SA", label: "Saudi Arabia" },
        { value: "SN", label: "Senegal" },
        { value: "RS", label: "Serbia" },
        { value: "SC", label: "Seychelles" },
        { value: "SL", label: "Sierra Leone" },
        { value: "SG", label: "Singapore" },
        { value: "SK", label: "Slovakia (Slovak Republic)" },
        { value: "SI", label: "Slovenia" },
        { value: "SB", label: "Solomon Islands" },
        { value: "SO", label: "Somalia, Somali Republic" },
        { value: "ZA", label: "South Africa" },
        { value: "GS", label: "South Georgia and the South Sandwich Islands" },
        { value: "ES", label: "Spain" },
        { value: "LK", label: "Sri Lanka" },
        { value: "SD", label: "Sudan" },
        { value: "SR", label: "Suriname" },
        { value: "SJ", label: "Svalbard &amp; Jan Mayen Islands" },
        { value: "SZ", label: "Swaziland" },
        { value: "SE", label: "Sweden" },
        { value: "CH", label: "Switzerland" },
        { value: "SY", label: "Syria" },
        { value: "TW", label: "Taiwan" },
        { value: "TJ", label: "Tajikistan" },
        { value: "TZ", label: "Tanzania" },
        { value: "TH", label: "Thailand" },
        { value: "TL", label: "Timor-Leste" },
        { value: "TG", label: "Togo" },
        { value: "TK", label: "Tokelau" },
        { value: "TO", label: "Tonga" },
        { value: "TT", label: "Trinidad and Tobago" },
        { value: "TN", label: "Tunisia" },
        { value: "TR", label: "Turkey" },
        { value: "TM", label: "Turkmenistan" },
        { value: "TC", label: "Turks and Caicos Islands" },
        { value: "TV", label: "Tuvalu" },
        { value: "UG", label: "Uganda" },
        { value: "UA", label: "Ukraine" },
        { value: "AE", label: "United Arab Emirates" },
        { value: "GB", label: "United Kingdom" },
        { value: "US", label: "United States" },
        { value: "UM", label: "United States Minor Outlying Islands" },
        { value: "VI", label: "United States Virgin Islands" },
        { value: "UY", label: "Uruguay" },
        { value: "UZ", label: "Uzbekistan" },
        { value: "VU", label: "Vanuatu" },
        { value: "VE", label: "Venezuela" },
        { value: "VN", label: "Vietnam" },
        { value: "WF", label: "Wallis and Futuna" },
        { value: "EH", label: "Western Sahara" },
        { value: "YE", label: "Yemen" },
        { value: "ZM", label: "Zambia" },
        { value: "ZW", label: "Zimbabwe" },
    ],

    timezones: [
        { value: "Pacific/Midway", label: "GMT-11 (SST) – Pacific/Midway" },
        { value: "Pacific/Niue", label: "GMT-11 (-11) – Pacific/Niue" },
        { value: "Pacific/Pago_Pago", label: "GMT-11 (SST) – Pacific/Pago_Pago" },
        { value: "Pacific/Honolulu", label: "GMT-10 (HST) – Pacific/Honolulu" },
        { value: "Pacific/Rarotonga", label: "GMT-10 (-10) – Pacific/Rarotonga" },
        { value: "Pacific/Tahiti", label: "GMT-10 (-10) – Pacific/Tahiti" },
        { value: "Pacific/Marquesas", label: "GMT-10:30 (-0930) – Pacific/Marquesas" },
        { value: "America/Adak", label: "GMT-9 (HDT) – America/Adak" },
        { value: "Pacific/Gambier", label: "GMT-9 (-09) – Pacific/Gambier" },
        { value: "America/Anchorage", label: "GMT-8 (AKDT) – America/Anchorage" },
        { value: "America/Juneau", label: "GMT-8 (AKDT) – America/Juneau" },
        { value: "America/Metlakatla", label: "GMT-8 (AKDT) – America/Metlakatla" },
        { value: "America/Nome", label: "GMT-8 (AKDT) – America/Nome" },
        { value: "America/Sitka", label: "GMT-8 (AKDT) – America/Sitka" },
        { value: "America/Yakutat", label: "GMT-8 (AKDT) – America/Yakutat" },
        { value: "Pacific/Pitcairn", label: "GMT-8 (-08) – Pacific/Pitcairn" },
        { value: "America/Chihuahua", label: "GMT-7 (MST) – America/Chihuahua" },
        { value: "America/Creston", label: "GMT-7 (MST) – America/Creston" },
        { value: "America/Dawson", label: "GMT-7 (MST) – America/Dawson" },
        { value: "America/Dawson_Creek", label: "GMT-7 (MST) – America/Dawson_Creek" },
        { value: "America/Fort_Nelson", label: "GMT-7 (MST) – America/Fort_Nelson" },
        { value: "America/Hermosillo", label: "GMT-7 (MST) – America/Hermosillo" },
        { value: "America/Los_Angeles", label: "GMT-7 (PDT) – America/Los_Angeles" },
        { value: "America/Mazatlan", label: "GMT-7 (MST) – America/Mazatlan" },
        { value: "America/Phoenix", label: "GMT-7 (MST) – America/Phoenix" },
        { value: "America/Tijuana", label: "GMT-7 (PDT) – America/Tijuana" },
        { value: "America/Vancouver", label: "GMT-7 (PDT) – America/Vancouver" },
        { value: "America/Whitehorse", label: "GMT-7 (MST) – America/Whitehorse" },
        { value: "America/Bahia_Banderas", label: "GMT-6 (CST) – America/Bahia_Banderas" },
        { value: "America/Belize", label: "GMT-6 (CST) – America/Belize" },
        { value: "America/Boise", label: "GMT-6 (MDT) – America/Boise" },
        { value: "America/Cambridge_Bay", label: "GMT-6 (MDT) – America/Cambridge_Bay" },
        { value: "America/Costa_Rica", label: "GMT-6 (CST) – America/Costa_Rica" },
        { value: "America/Denver", label: "GMT-6 (MDT) – America/Denver" },
        { value: "America/Edmonton", label: "GMT-6 (MDT) – America/Edmonton" },
        { value: "America/El_Salvador", label: "GMT-6 (CST) – America/El_Salvador" },
        { value: "America/Guatemala", label: "GMT-6 (CST) – America/Guatemala" },
        { value: "America/Inuvik", label: "GMT-6 (MDT) – America/Inuvik" },
        { value: "America/Managua", label: "GMT-6 (CST) – America/Managua" },
        { value: "America/Merida", label: "GMT-6 (CST) – America/Merida" },
        { value: "America/Mexico_City", label: "GMT-6 (CST) – America/Mexico_City" },
        { value: "America/Monterrey", label: "GMT-6 (CST) – America/Monterrey" },
        { value: "America/Ojinaga", label: "GMT-6 (MDT) – America/Ojinaga" },
        { value: "America/Regina", label: "GMT-6 (CST) – America/Regina" },
        { value: "America/Swift_Current", label: "GMT-6 (CST) – America/Swift_Current" },
        { value: "America/Tegucigalpa", label: "GMT-6 (CST) – America/Tegucigalpa" },
        { value: "America/Yellowknife", label: "GMT-6 (MDT) – America/Yellowknife" },
        { value: "Pacific/Galapagos", label: "GMT-6 (-06) – Pacific/Galapagos" },
        { value: "America/Atikokan", label: "GMT-5 (EST) – America/Atikokan" },
        { value: "America/Bogota", label: "GMT-5 (-05) – America/Bogota" },
        { value: "America/Cancun", label: "GMT-5 (EST) – America/Cancun" },
        { value: "America/Cayman", label: "GMT-5 (EST) – America/Cayman" },
        { value: "America/Chicago", label: "GMT-5 (CDT) – America/Chicago" },
        { value: "America/Eirunepe", label: "GMT-5 (-05) – America/Eirunepe" },
        { value: "America/Guayaquil", label: "GMT-5 (-05) – America/Guayaquil" },
        { value: "America/Indiana/Knox", label: "GMT-5 (CDT) – America/Indiana/Knox" },
        { value: "America/Indiana/Tell_City", label: "GMT-5 (CDT) – America/Indiana/Tell_City" },
        { value: "America/Jamaica", label: "GMT-5 (EST) – America/Jamaica" },
        { value: "America/Lima", label: "GMT-5 (-05) – America/Lima" },
        { value: "America/Matamoros", label: "GMT-5 (CDT) – America/Matamoros" },
        { value: "America/Menominee", label: "GMT-5 (CDT) – America/Menominee" },
        { value: "America/North_Dakota/Beulah", label: "GMT-5 (CDT) – America/North_Dakota/Beulah" },
        { value: "America/North_Dakota/Center", label: "GMT-5 (CDT) – America/North_Dakota/Center" },
        { value: "America/North_Dakota/New_Salem", label: "GMT-5 (CDT) – America/North_Dakota/New_Salem" },
        { value: "America/Panama", label: "GMT-5 (EST) – America/Panama" },
        { value: "America/Rainy_River", label: "GMT-5 (CDT) – America/Rainy_River" },
        { value: "America/Rankin_Inlet", label: "GMT-5 (CDT) – America/Rankin_Inlet" },
        { value: "America/Resolute", label: "GMT-5 (CDT) – America/Resolute" },
        { value: "America/Rio_Branco", label: "GMT-5 (-05) – America/Rio_Branco" },
        { value: "America/Winnipeg", label: "GMT-5 (CDT) – America/Winnipeg" },
        { value: "Pacific/Easter", label: "GMT-5 (-05) – Pacific/Easter" },
        { value: "America/Anguilla", label: "GMT-4 (AST) – America/Anguilla" },
        { value: "America/Antigua", label: "GMT-4 (AST) – America/Antigua" },
        { value: "America/Aruba", label: "GMT-4 (AST) – America/Aruba" },
        { value: "America/Barbados", label: "GMT-4 (AST) – America/Barbados" },
        { value: "America/Blanc-Sablon", label: "GMT-4 (AST) – America/Blanc-Sablon" },
        { value: "America/Boa_Vista", label: "GMT-4 (-04) – America/Boa_Vista" },
        { value: "America/Campo_Grande", label: "GMT-4 (-04) – America/Campo_Grande" },
        { value: "America/Caracas", label: "GMT-4 (-04) – America/Caracas" },
        { value: "America/Cuiaba", label: "GMT-4 (-04) – America/Cuiaba" },
        { value: "America/Curacao", label: "GMT-4 (AST) – America/Curacao" },
        { value: "America/Detroit", label: "GMT-4 (EDT) – America/Detroit" },
        { value: "America/Dominica", label: "GMT-4 (AST) – America/Dominica" },
        { value: "America/Grand_Turk", label: "GMT-4 (EDT) – America/Grand_Turk" },
        { value: "America/Grenada", label: "GMT-4 (AST) – America/Grenada" },
        { value: "America/Guadeloupe", label: "GMT-4 (AST) – America/Guadeloupe" },
        { value: "America/Guyana", label: "GMT-4 (-04) – America/Guyana" },
        { value: "America/Havana", label: "GMT-4 (CDT) – America/Havana" },
        { value: "America/Indiana/Indianapolis", label: "GMT-4 (EDT) – America/Indiana/Indianapolis" },
        { value: "America/Indiana/Marengo", label: "GMT-4 (EDT) – America/Indiana/Marengo" },
        { value: "America/Indiana/Petersburg", label: "GMT-4 (EDT) – America/Indiana/Petersburg" },
        { value: "America/Indiana/Vevay", label: "GMT-4 (EDT) – America/Indiana/Vevay" },
        { value: "America/Indiana/Vincennes", label: "GMT-4 (EDT) – America/Indiana/Vincennes" },
        { value: "America/Indiana/Winamac", label: "GMT-4 (EDT) – America/Indiana/Winamac" },
        { value: "America/Iqaluit", label: "GMT-4 (EDT) – America/Iqaluit" },
        { value: "America/Kentucky/Louisville", label: "GMT-4 (EDT) – America/Kentucky/Louisville" },
        { value: "America/Kentucky/Monticello", label: "GMT-4 (EDT) – America/Kentucky/Monticello" },
        { value: "America/Kralendijk", label: "GMT-4 (AST) – America/Kralendijk" },
        { value: "America/La_Paz", label: "GMT-4 (-04) – America/La_Paz" },
        { value: "America/Lower_Princes", label: "GMT-4 (AST) – America/Lower_Princes" },
        { value: "America/Manaus", label: "GMT-4 (-04) – America/Manaus" },
        { value: "America/Marigot", label: "GMT-4 (AST) – America/Marigot" },
        { value: "America/Martinique", label: "GMT-4 (AST) – America/Martinique" },
        { value: "America/Montserrat", label: "GMT-4 (AST) – America/Montserrat" },
        { value: "America/Nassau", label: "GMT-4 (EDT) – America/Nassau" },
        { value: "America/New_York", label: "GMT-4 (EDT) – America/New_York" },
        { value: "America/Nipigon", label: "GMT-4 (EDT) – America/Nipigon" },
        { value: "America/Pangnirtung", label: "GMT-4 (EDT) – America/Pangnirtung" },
        { value: "America/Port-au-Prince", label: "GMT-4 (EDT) – America/Port-au-Prince" },
        { value: "America/Port_of_Spain", label: "GMT-4 (AST) – America/Port_of_Spain" },
        { value: "America/Porto_Velho", label: "GMT-4 (-04) – America/Porto_Velho" },
        { value: "America/Puerto_Rico", label: "GMT-4 (AST) – America/Puerto_Rico" },
        { value: "America/Santo_Domingo", label: "GMT-4 (AST) – America/Santo_Domingo" },
        { value: "America/St_Barthelemy", label: "GMT-4 (AST) – America/St_Barthelemy" },
        { value: "America/St_Kitts", label: "GMT-4 (AST) – America/St_Kitts" },
        { value: "America/St_Lucia", label: "GMT-4 (AST) – America/St_Lucia" },
        { value: "America/St_Thomas", label: "GMT-4 (AST) – America/St_Thomas" },
        { value: "America/St_Vincent", label: "GMT-4 (AST) – America/St_Vincent" },
        { value: "America/Thunder_Bay", label: "GMT-4 (EDT) – America/Thunder_Bay" },
        { value: "America/Toronto", label: "GMT-4 (EDT) – America/Toronto" },
        { value: "America/Tortola", label: "GMT-4 (AST) – America/Tortola" },
        { value: "America/Araguaina", label: "GMT-3 (-03) – America/Araguaina" },
        { value: "America/Argentina/Buenos_Aires", label: "GMT-3 (-03) – America/Argentina/Buenos_Aires" },
        { value: "America/Argentina/Catamarca", label: "GMT-3 (-03) – America/Argentina/Catamarca" },
        { value: "America/Argentina/Cordoba", label: "GMT-3 (-03) – America/Argentina/Cordoba" },
        { value: "America/Argentina/Jujuy", label: "GMT-3 (-03) – America/Argentina/Jujuy" },
        { value: "America/Argentina/La_Rioja", label: "GMT-3 (-03) – America/Argentina/La_Rioja" },
        { value: "America/Argentina/Mendoza", label: "GMT-3 (-03) – America/Argentina/Mendoza" },
        { value: "America/Argentina/Rio_Gallegos", label: "GMT-3 (-03) – America/Argentina/Rio_Gallegos" },
        { value: "America/Argentina/Salta", label: "GMT-3 (-03) – America/Argentina/Salta" },
        { value: "America/Argentina/San_Juan", label: "GMT-3 (-03) – America/Argentina/San_Juan" },
        { value: "America/Argentina/San_Luis", label: "GMT-3 (-03) – America/Argentina/San_Luis" },
        { value: "America/Argentina/Tucuman", label: "GMT-3 (-03) – America/Argentina/Tucuman" },
        { value: "America/Argentina/Ushuaia", label: "GMT-3 (-03) – America/Argentina/Ushuaia" },
        { value: "America/Asuncion", label: "GMT-3 (-03) – America/Asuncion" },
        { value: "America/Bahia", label: "GMT-3 (-03) – America/Bahia" },
        { value: "America/Belem", label: "GMT-3 (-03) – America/Belem" },
        { value: "America/Cayenne", label: "GMT-3 (-03) – America/Cayenne" },
        { value: "America/Fortaleza", label: "GMT-3 (-03) – America/Fortaleza" },
        { value: "America/Glace_Bay", label: "GMT-3 (ADT) – America/Glace_Bay" },
        { value: "America/Goose_Bay", label: "GMT-3 (ADT) – America/Goose_Bay" },
        { value: "America/Halifax", label: "GMT-3 (ADT) – America/Halifax" },
        { value: "America/Maceio", label: "GMT-3 (-03) – America/Maceio" },
        { value: "America/Moncton", label: "GMT-3 (ADT) – America/Moncton" },
        { value: "America/Montevideo", label: "GMT-3 (-03) – America/Montevideo" },
        { value: "America/Nuuk", label: "GMT-3 (-03) – America/Nuuk" },
        { value: "America/Paramaribo", label: "GMT-3 (-03) – America/Paramaribo" },
        { value: "America/Punta_Arenas", label: "GMT-3 (-03) – America/Punta_Arenas" },
        { value: "America/Recife", label: "GMT-3 (-03) – America/Recife" },
        { value: "America/Santarem", label: "GMT-3 (-03) – America/Santarem" },
        { value: "America/Santiago", label: "GMT-3 (-03) – America/Santiago" },
        { value: "America/Sao_Paulo", label: "GMT-3 (-03) – America/Sao_Paulo" },
        { value: "America/Thule", label: "GMT-3 (ADT) – America/Thule" },
        { value: "Antarctica/Palmer", label: "GMT-3 (-03) – Antarctica/Palmer" },
        { value: "Antarctica/Rothera", label: "GMT-3 (-03) – Antarctica/Rothera" },
        { value: "Atlantic/Bermuda", label: "GMT-3 (ADT) – Atlantic/Bermuda" },
        { value: "Atlantic/Stanley", label: "GMT-3 (-03) – Atlantic/Stanley" },
        { value: "America/St_Johns", label: "GMT-3:30 (NDT) – America/St_Johns" },
        { value: "America/Miquelon", label: "GMT-2 (-02) – America/Miquelon" },
        { value: "America/Noronha", label: "GMT-2 (-02) – America/Noronha" },
        { value: "Atlantic/South_Georgia", label: "GMT-2 (-02) – Atlantic/South_Georgia" },
        { value: "America/Scoresbysund", label: "GMT-1 (-01) – America/Scoresbysund" },
        { value: "Atlantic/Azores", label: "GMT-1 (-01) – Atlantic/Azores" },
        { value: "Atlantic/Cape_Verde", label: "GMT-1 (-01) – Atlantic/Cape_Verde" },
        { value: "Africa/Abidjan", label: "GMT (GMT) – Africa/Abidjan" },
        { value: "Africa/Accra", label: "GMT (GMT) – Africa/Accra" },
        { value: "Africa/Bamako", label: "GMT (GMT) – Africa/Bamako" },
        { value: "Africa/Banjul", label: "GMT (GMT) – Africa/Banjul" },
        { value: "Africa/Bissau", label: "GMT (GMT) – Africa/Bissau" },
        { value: "Africa/Conakry", label: "GMT (GMT) – Africa/Conakry" },
        { value: "Africa/Dakar", label: "GMT (GMT) – Africa/Dakar" },
        { value: "Africa/Freetown", label: "GMT (GMT) – Africa/Freetown" },
        { value: "Africa/Lome", label: "GMT (GMT) – Africa/Lome" },
        { value: "Africa/Monrovia", label: "GMT (GMT) – Africa/Monrovia" },
        { value: "Africa/Nouakchott", label: "GMT (GMT) – Africa/Nouakchott" },
        { value: "Africa/Ouagadougou", label: "GMT (GMT) – Africa/Ouagadougou" },
        { value: "Africa/Sao_Tome", label: "GMT (GMT) – Africa/Sao_Tome" },
        { value: "America/Danmarkshavn", label: "GMT (GMT) – America/Danmarkshavn" },
        { value: "Antarctica/Troll", label: "GMT (+00) – Antarctica/Troll" },
        { value: "Atlantic/Canary", label: "GMT (WET) – Atlantic/Canary" },
        { value: "Atlantic/Faroe", label: "GMT (WET) – Atlantic/Faroe" },
        { value: "Atlantic/Madeira", label: "GMT (WET) – Atlantic/Madeira" },
        { value: "Atlantic/Reykjavik", label: "GMT (GMT) – Atlantic/Reykjavik" },
        { value: "Atlantic/St_Helena", label: "GMT (GMT) – Atlantic/St_Helena" },
        { value: "Europe/Dublin", label: "GMT (GMT) – Europe/Dublin" },
        { value: "Europe/Guernsey", label: "GMT (GMT) – Europe/Guernsey" },
        { value: "Europe/Isle_of_Man", label: "GMT (GMT) – Europe/Isle_of_Man" },
        { value: "Europe/Jersey", label: "GMT (GMT) – Europe/Jersey" },
        { value: "Europe/Lisbon", label: "GMT (WET) – Europe/Lisbon" },
        { value: "Europe/London", label: "GMT (GMT) – Europe/London" },
        { value: "UTC", label: "GMT" },
        { value: "Africa/Algiers", label: "GMT+1 (CET) – Africa/Algiers" },
        { value: "Africa/Bangui", label: "GMT+1 (WAT) – Africa/Bangui" },
        { value: "Africa/Brazzaville", label: "GMT+1 (WAT) – Africa/Brazzaville" },
        { value: "Africa/Casablanca", label: "GMT+1 (+01) – Africa/Casablanca" },
        { value: "Africa/Ceuta", label: "GMT+1 (CET) – Africa/Ceuta" },
        { value: "Africa/Douala", label: "GMT+1 (WAT) – Africa/Douala" },
        { value: "Africa/El_Aaiun", label: "GMT+1 (+01) – Africa/El_Aaiun" },
        { value: "Africa/Kinshasa", label: "GMT+1 (WAT) – Africa/Kinshasa" },
        { value: "Africa/Lagos", label: "GMT+1 (WAT) – Africa/Lagos" },
        { value: "Africa/Libreville", label: "GMT+1 (WAT) – Africa/Libreville" },
        { value: "Africa/Luanda", label: "GMT+1 (WAT) – Africa/Luanda" },
        { value: "Africa/Malabo", label: "GMT+1 (WAT) – Africa/Malabo" },
        { value: "Africa/Ndjamena", label: "GMT+1 (WAT) – Africa/Ndjamena" },
        { value: "Africa/Niamey", label: "GMT+1 (WAT) – Africa/Niamey" },
        { value: "Africa/Porto-Novo", label: "GMT+1 (WAT) – Africa/Porto-Novo" },
        { value: "Africa/Tunis", label: "GMT+1 (CET) – Africa/Tunis" },
        { value: "Arctic/Longyearbyen", label: "GMT+1 (CET) – Arctic/Longyearbyen" },
        { value: "Europe/Amsterdam", label: "GMT+1 (CET) – Europe/Amsterdam" },
        { value: "Europe/Andorra", label: "GMT+1 (CET) – Europe/Andorra" },
        { value: "Europe/Belgrade", label: "GMT+1 (CET) – Europe/Belgrade" },
        { value: "Europe/Berlin", label: "GMT+1 (CET) – Europe/Berlin" },
        { value: "Europe/Bratislava", label: "GMT+1 (CET) – Europe/Bratislava" },
        { value: "Europe/Brussels", label: "GMT+1 (CET) – Europe/Brussels" },
        { value: "Europe/Budapest", label: "GMT+1 (CET) – Europe/Budapest" },
        { value: "Europe/Busingen", label: "GMT+1 (CET) – Europe/Busingen" },
        { value: "Europe/Copenhagen", label: "GMT+1 (CET) – Europe/Copenhagen" },
        { value: "Europe/Gibraltar", label: "GMT+1 (CET) – Europe/Gibraltar" },
        { value: "Europe/Ljubljana", label: "GMT+1 (CET) – Europe/Ljubljana" },
        { value: "Europe/Luxembourg", label: "GMT+1 (CET) – Europe/Luxembourg" },
        { value: "Europe/Madrid", label: "GMT+1 (CET) – Europe/Madrid" },
        { value: "Europe/Malta", label: "GMT+1 (CET) – Europe/Malta" },
        { value: "Europe/Monaco", label: "GMT+1 (CET) – Europe/Monaco" },
        { value: "Europe/Oslo", label: "GMT+1 (CET) – Europe/Oslo" },
        { value: "Europe/Paris", label: "GMT+1 (CET) – Europe/Paris" },
        { value: "Europe/Podgorica", label: "GMT+1 (CET) – Europe/Podgorica" },
        { value: "Europe/Prague", label: "GMT+1 (CET) – Europe/Prague" },
        { value: "Europe/Rome", label: "GMT+1 (CET) – Europe/Rome" },
        { value: "Europe/San_Marino", label: "GMT+1 (CET) – Europe/San_Marino" },
        { value: "Europe/Sarajevo", label: "GMT+1 (CET) – Europe/Sarajevo" },
        { value: "Europe/Skopje", label: "GMT+1 (CET) – Europe/Skopje" },
        { value: "Europe/Stockholm", label: "GMT+1 (CET) – Europe/Stockholm" },
        { value: "Europe/Tirane", label: "GMT+1 (CET) – Europe/Tirane" },
        { value: "Europe/Vaduz", label: "GMT+1 (CET) – Europe/Vaduz" },
        { value: "Europe/Vatican", label: "GMT+1 (CET) – Europe/Vatican" },
        { value: "Europe/Vienna", label: "GMT+1 (CET) – Europe/Vienna" },
        { value: "Europe/Warsaw", label: "GMT+1 (CET) – Europe/Warsaw" },
        { value: "Europe/Zagreb", label: "GMT+1 (CET) – Europe/Zagreb" },
        { value: "Europe/Zurich", label: "GMT+1 (CET) – Europe/Zurich" },
        { value: "Africa/Blantyre", label: "GMT+2 (CAT) – Africa/Blantyre" },
        { value: "Africa/Bujumbura", label: "GMT+2 (CAT) – Africa/Bujumbura" },
        { value: "Africa/Cairo", label: "GMT+2 (EET) – Africa/Cairo" },
        { value: "Africa/Gaborone", label: "GMT+2 (CAT) – Africa/Gaborone" },
        { value: "Africa/Harare", label: "GMT+2 (CAT) – Africa/Harare" },
        { value: "Africa/Johannesburg", label: "GMT+2 (SAST) – Africa/Johannesburg" },
        { value: "Africa/Khartoum", label: "GMT+2 (CAT) – Africa/Khartoum" },
        { value: "Africa/Kigali", label: "GMT+2 (CAT) – Africa/Kigali" },
        { value: "Africa/Lubumbashi", label: "GMT+2 (CAT) – Africa/Lubumbashi" },
        { value: "Africa/Lusaka", label: "GMT+2 (CAT) – Africa/Lusaka" },
        { value: "Africa/Maputo", label: "GMT+2 (CAT) – Africa/Maputo" },
        { value: "Africa/Maseru", label: "GMT+2 (SAST) – Africa/Maseru" },
        { value: "Africa/Mbabane", label: "GMT+2 (SAST) – Africa/Mbabane" },
        { value: "Africa/Tripoli", label: "GMT+2 (EET) – Africa/Tripoli" },
        { value: "Africa/Windhoek", label: "GMT+2 (CAT) – Africa/Windhoek" },
        { value: "Asia/Amman", label: "GMT+2 (EET) – Asia/Amman" },
        { value: "Asia/Beirut", label: "GMT+2 (EET) – Asia/Beirut" },
        { value: "Asia/Damascus", label: "GMT+2 (EET) – Asia/Damascus" },
        { value: "Asia/Famagusta", label: "GMT+2 (EET) – Asia/Famagusta" },
        { value: "Asia/Gaza", label: "GMT+2 (EET) – Asia/Gaza" },
        { value: "Asia/Hebron", label: "GMT+2 (EET) – Asia/Hebron" },
        { value: "Asia/Jerusalem", label: "GMT+2 (IST) – Asia/Jerusalem" },
        { value: "Asia/Nicosia", label: "GMT+2 (EET) – Asia/Nicosia" },
        { value: "Europe/Athens", label: "GMT+2 (EET) – Europe/Athens" },
        { value: "Europe/Bucharest", label: "GMT+2 (EET) – Europe/Bucharest" },
        { value: "Europe/Chisinau", label: "GMT+2 (EET) – Europe/Chisinau" },
        { value: "Europe/Helsinki", label: "GMT+2 (EET) – Europe/Helsinki" },
        { value: "Europe/Kaliningrad", label: "GMT+2 (EET) – Europe/Kaliningrad" },
        { value: "Europe/Kiev", label: "GMT+2 (EET) – Europe/Kiev" },
        { value: "Europe/Mariehamn", label: "GMT+2 (EET) – Europe/Mariehamn" },
        { value: "Europe/Riga", label: "GMT+2 (EET) – Europe/Riga" },
        { value: "Europe/Sofia", label: "GMT+2 (EET) – Europe/Sofia" },
        { value: "Europe/Tallinn", label: "GMT+2 (EET) – Europe/Tallinn" },
        { value: "Europe/Uzhgorod", label: "GMT+2 (EET) – Europe/Uzhgorod" },
        { value: "Europe/Vilnius", label: "GMT+2 (EET) – Europe/Vilnius" },
        { value: "Europe/Zaporozhye", label: "GMT+2 (EET) – Europe/Zaporozhye" },
        { value: "Africa/Addis_Ababa", label: "GMT+3 (EAT) – Africa/Addis_Ababa" },
        { value: "Africa/Asmara", label: "GMT+3 (EAT) – Africa/Asmara" },
        { value: "Africa/Dar_es_Salaam", label: "GMT+3 (EAT) – Africa/Dar_es_Salaam" },
        { value: "Africa/Djibouti", label: "GMT+3 (EAT) – Africa/Djibouti" },
        { value: "Africa/Juba", label: "GMT+3 (EAT) – Africa/Juba" },
        { value: "Africa/Kampala", label: "GMT+3 (EAT) – Africa/Kampala" },
        { value: "Africa/Mogadishu", label: "GMT+3 (EAT) – Africa/Mogadishu" },
        { value: "Africa/Nairobi", label: "GMT+3 (EAT) – Africa/Nairobi" },
        { value: "Antarctica/Syowa", label: "GMT+3 (+03) – Antarctica/Syowa" },
        { value: "Asia/Aden", label: "GMT+3 (+03) – Asia/Aden" },
        { value: "Asia/Baghdad", label: "GMT+3 (+03) – Asia/Baghdad" },
        { value: "Asia/Bahrain", label: "GMT+3 (+03) – Asia/Bahrain" },
        { value: "Asia/Kuwait", label: "GMT+3 (+03) – Asia/Kuwait" },
        { value: "Asia/Qatar", label: "GMT+3 (+03) – Asia/Qatar" },
        { value: "Asia/Riyadh", label: "GMT+3 (+03) – Asia/Riyadh" },
        { value: "Europe/Istanbul", label: "GMT+3 (+03) – Europe/Istanbul" },
        { value: "Europe/Kirov", label: "GMT+3 (+03) – Europe/Kirov" },
        { value: "Europe/Minsk", label: "GMT+3 (+03) – Europe/Minsk" },
        { value: "Europe/Moscow", label: "GMT+3 (MSK) – Europe/Moscow" },
        { value: "Europe/Simferopol", label: "GMT+3 (MSK) – Europe/Simferopol" },
        { value: "Indian/Antananarivo", label: "GMT+3 (EAT) – Indian/Antananarivo" },
        { value: "Indian/Comoro", label: "GMT+3 (EAT) – Indian/Comoro" },
        { value: "Indian/Mayotte", label: "GMT+3 (EAT) – Indian/Mayotte" },
        { value: "Asia/Tehran", label: "GMT+3:30 (+0330) – Asia/Tehran" },
        { value: "Asia/Baku", label: "GMT+4 (+04) – Asia/Baku" },
        { value: "Asia/Dubai", label: "GMT+4 (+04) – Asia/Dubai" },
        { value: "Asia/Muscat", label: "GMT+4 (+04) – Asia/Muscat" },
        { value: "Asia/Tbilisi", label: "GMT+4 (+04) – Asia/Tbilisi" },
        { value: "Asia/Yerevan", label: "GMT+4 (+04) – Asia/Yerevan" },
        { value: "Europe/Astrakhan", label: "GMT+4 (+04) – Europe/Astrakhan" },
        { value: "Europe/Samara", label: "GMT+4 (+04) – Europe/Samara" },
        { value: "Europe/Saratov", label: "GMT+4 (+04) – Europe/Saratov" },
        { value: "Europe/Ulyanovsk", label: "GMT+4 (+04) – Europe/Ulyanovsk" },
        { value: "Europe/Volgograd", label: "GMT+4 (+04) – Europe/Volgograd" },
        { value: "Indian/Mahe", label: "GMT+4 (+04) – Indian/Mahe" },
        { value: "Indian/Mauritius", label: "GMT+4 (+04) – Indian/Mauritius" },
        { value: "Indian/Reunion", label: "GMT+4 (+04) – Indian/Reunion" },
        { value: "Asia/Kabul", label: "GMT+4:30 (+0430) – Asia/Kabul" },
        { value: "Antarctica/Mawson", label: "GMT+5 (+05) – Antarctica/Mawson" },
        { value: "Asia/Aqtau", label: "GMT+5 (+05) – Asia/Aqtau" },
        { value: "Asia/Aqtobe", label: "GMT+5 (+05) – Asia/Aqtobe" },
        { value: "Asia/Ashgabat", label: "GMT+5 (+05) – Asia/Ashgabat" },
        { value: "Asia/Atyrau", label: "GMT+5 (+05) – Asia/Atyrau" },
        { value: "Asia/Dushanbe", label: "GMT+5 (+05) – Asia/Dushanbe" },
        { value: "Asia/Karachi", label: "GMT+5 (PKT) – Asia/Karachi" },
        { value: "Asia/Oral", label: "GMT+5 (+05) – Asia/Oral" },
        { value: "Asia/Qyzylorda", label: "GMT+5 (+05) – Asia/Qyzylorda" },
        { value: "Asia/Samarkand", label: "GMT+5 (+05) – Asia/Samarkand" },
        { value: "Asia/Tashkent", label: "GMT+5 (+05) – Asia/Tashkent" },
        { value: "Asia/Yekaterinburg", label: "GMT+5 (+05) – Asia/Yekaterinburg" },
        { value: "Indian/Kerguelen", label: "GMT+5 (+05) – Indian/Kerguelen" },
        { value: "Indian/Maldives", label: "GMT+5 (+05) – Indian/Maldives" },
        { value: "Asia/Colombo", label: "GMT+5:30 (+0530) – Asia/Colombo" },
        { value: "Asia/Kolkata", label: "GMT+5:30 (IST) – Asia/Kolkata" },
        { value: "Asia/Kathmandu", label: "GMT+5:45 (+0545) – Asia/Kathmandu" },
        { value: "Antarctica/Vostok", label: "GMT+6 (+06) – Antarctica/Vostok" },
        { value: "Asia/Almaty", label: "GMT+6 (+06) – Asia/Almaty" },
        { value: "Asia/Bishkek", label: "GMT+6 (+06) – Asia/Bishkek" },
        { value: "Asia/Dhaka", label: "GMT+6 (+06) – Asia/Dhaka" },
        { value: "Asia/Omsk", label: "GMT+6 (+06) – Asia/Omsk" },
        { value: "Asia/Qostanay", label: "GMT+6 (+06) – Asia/Qostanay" },
        { value: "Asia/Thimphu", label: "GMT+6 (+06) – Asia/Thimphu" },
        { value: "Asia/Urumqi", label: "GMT+6 (+06) – Asia/Urumqi" },
        { value: "Indian/Chagos", label: "GMT+6 (+06) – Indian/Chagos" },
        { value: "Asia/Yangon", label: "GMT+6:30 (+0630) – Asia/Yangon" },
        { value: "Indian/Cocos", label: "GMT+6:30 (+0630) – Indian/Cocos" },
        { value: "Antarctica/Davis", label: "GMT+7 (+07) – Antarctica/Davis" },
        { value: "Asia/Bangkok", label: "GMT+7 (+07) – Asia/Bangkok" },
        { value: "Asia/Barnaul", label: "GMT+7 (+07) – Asia/Barnaul" },
        { value: "Asia/Ho_Chi_Minh", label: "GMT+7 (+07) – Asia/Ho_Chi_Minh" },
        { value: "Asia/Hovd", label: "GMT+7 (+07) – Asia/Hovd" },
        { value: "Asia/Jakarta", label: "GMT+7 (WIB) – Asia/Jakarta" },
        { value: "Asia/Krasnoyarsk", label: "GMT+7 (+07) – Asia/Krasnoyarsk" },
        { value: "Asia/Novokuznetsk", label: "GMT+7 (+07) – Asia/Novokuznetsk" },
        { value: "Asia/Novosibirsk", label: "GMT+7 (+07) – Asia/Novosibirsk" },
        { value: "Asia/Phnom_Penh", label: "GMT+7 (+07) – Asia/Phnom_Penh" },
        { value: "Asia/Pontianak", label: "GMT+7 (WIB) – Asia/Pontianak" },
        { value: "Asia/Tomsk", label: "GMT+7 (+07) – Asia/Tomsk" },
        { value: "Asia/Vientiane", label: "GMT+7 (+07) – Asia/Vientiane" },
        { value: "Indian/Christmas", label: "GMT+7 (+07) – Indian/Christmas" },
        { value: "Antarctica/Casey", label: "GMT+8 (+08) – Antarctica/Casey" },
        { value: "Asia/Brunei", label: "GMT+8 (+08) – Asia/Brunei" },
        { value: "Asia/Choibalsan", label: "GMT+8 (+08) – Asia/Choibalsan" },
        { value: "Asia/Hong_Kong", label: "GMT+8 (HKT) – Asia/Hong_Kong" },
        { value: "Asia/Irkutsk", label: "GMT+8 (+08) – Asia/Irkutsk" },
        { value: "Asia/Kuala_Lumpur", label: "GMT+8 (+08) – Asia/Kuala_Lumpur" },
        { value: "Asia/Kuching", label: "GMT+8 (+08) – Asia/Kuching" },
        { value: "Asia/Macau", label: "GMT+8 (CST) – Asia/Macau" },
        { value: "Asia/Makassar", label: "GMT+8 (WITA) – Asia/Makassar" },
        { value: "Asia/Manila", label: "GMT+8 (PST) – Asia/Manila" },
        { value: "Asia/Shanghai", label: "GMT+8 (CST) – Asia/Shanghai" },
        { value: "Asia/Singapore", label: "GMT+8 (+08) – Asia/Singapore" },
        { value: "Asia/Taipei", label: "GMT+8 (CST) – Asia/Taipei" },
        { value: "Asia/Ulaanbaatar", label: "GMT+8 (+08) – Asia/Ulaanbaatar" },
        { value: "Australia/Perth", label: "GMT+8 (AWST) – Australia/Perth" },
        { value: "Australia/Eucla", label: "GMT+8:45 (+0845) – Australia/Eucla" },
        { value: "Asia/Chita", label: "GMT+9 (+09) – Asia/Chita" },
        { value: "Asia/Dili", label: "GMT+9 (+09) – Asia/Dili" },
        { value: "Asia/Jayapura", label: "GMT+9 (WIT) – Asia/Jayapura" },
        { value: "Asia/Khandyga", label: "GMT+9 (+09) – Asia/Khandyga" },
        { value: "Asia/Pyongyang", label: "GMT+9 (KST) – Asia/Pyongyang" },
        { value: "Asia/Seoul", label: "GMT+9 (KST) – Asia/Seoul" },
        { value: "Asia/Tokyo", label: "GMT+9 (JST) – Asia/Tokyo" },
        { value: "Asia/Yakutsk", label: "GMT+9 (+09) – Asia/Yakutsk" },
        { value: "Pacific/Palau", label: "GMT+9 (+09) – Pacific/Palau" },
        { value: "Australia/Darwin", label: "GMT+9:30 (ACST) – Australia/Darwin" },
        { value: "Antarctica/DumontDUrville", label: "GMT+10 (+10) – Antarctica/DumontDUrville" },
        { value: "Asia/Ust-Nera", label: "GMT+10 (+10) – Asia/Ust-Nera" },
        { value: "Asia/Vladivostok", label: "GMT+10 (+10) – Asia/Vladivostok" },
        { value: "Australia/Brisbane", label: "GMT+10 (AEST) – Australia/Brisbane" },
        { value: "Australia/Lindeman", label: "GMT+10 (AEST) – Australia/Lindeman" },
        { value: "Pacific/Chuuk", label: "GMT+10 (+10) – Pacific/Chuuk" },
        { value: "Pacific/Guam", label: "GMT+10 (ChST) – Pacific/Guam" },
        { value: "Pacific/Port_Moresby", label: "GMT+10 (+10) – Pacific/Port_Moresby" },
        { value: "Pacific/Saipan", label: "GMT+10 (ChST) – Pacific/Saipan" },
        { value: "Australia/Adelaide", label: "GMT+10:30 (ACDT) – Australia/Adelaide" },
        { value: "Australia/Broken_Hill", label: "GMT+10:30 (ACDT) – Australia/Broken_Hill" },
        { value: "Antarctica/Macquarie", label: "GMT+11 (+11) – Antarctica/Macquarie" },
        { value: "Asia/Magadan", label: "GMT+11 (+11) – Asia/Magadan" },
        { value: "Asia/Sakhalin", label: "GMT+11 (+11) – Asia/Sakhalin" },
        { value: "Asia/Srednekolymsk", label: "GMT+11 (+11) – Asia/Srednekolymsk" },
        { value: "Australia/Currie", label: "GMT+11 (AEDT) – Australia/Currie" },
        { value: "Australia/Hobart", label: "GMT+11 (AEDT) – Australia/Hobart" },
        { value: "Australia/Lord_Howe", label: "GMT+11 (+11) – Australia/Lord_Howe" },
        { value: "Australia/Melbourne", label: "GMT+11 (AEDT) – Australia/Melbourne" },
        { value: "Australia/Sydney", label: "GMT+11 (AEDT) – Australia/Sydney" },
        { value: "Pacific/Bougainville", label: "GMT+11 (+11) – Pacific/Bougainville" },
        { value: "Pacific/Efate", label: "GMT+11 (+11) – Pacific/Efate" },
        { value: "Pacific/Guadalcanal", label: "GMT+11 (+11) – Pacific/Guadalcanal" },
        { value: "Pacific/Kosrae", label: "GMT+11 (+11) – Pacific/Kosrae" },
        { value: "Pacific/Noumea", label: "GMT+11 (+11) – Pacific/Noumea" },
        { value: "Pacific/Pohnpei", label: "GMT+11 (+11) – Pacific/Pohnpei" },
        { value: "Asia/Anadyr", label: "GMT+12 (+12) – Asia/Anadyr" },
        { value: "Asia/Kamchatka", label: "GMT+12 (+12) – Asia/Kamchatka" },
        { value: "Pacific/Fiji", label: "GMT+12 (+12) – Pacific/Fiji" },
        { value: "Pacific/Funafuti", label: "GMT+12 (+12) – Pacific/Funafuti" },
        { value: "Pacific/Kwajalein", label: "GMT+12 (+12) – Pacific/Kwajalein" },
        { value: "Pacific/Majuro", label: "GMT+12 (+12) – Pacific/Majuro" },
        { value: "Pacific/Nauru", label: "GMT+12 (+12) – Pacific/Nauru" },
        { value: "Pacific/Norfolk", label: "GMT+12 (+12) – Pacific/Norfolk" },
        { value: "Pacific/Tarawa", label: "GMT+12 (+12) – Pacific/Tarawa" },
        { value: "Pacific/Wake", label: "GMT+12 (+12) – Pacific/Wake" },
        { value: "Pacific/Wallis", label: "GMT+12 (+12) – Pacific/Wallis" },
        { value: "Antarctica/McMurdo", label: "GMT+13 (NZDT) – Antarctica/McMurdo" },
        { value: "Pacific/Auckland", label: "GMT+13 (NZDT) – Pacific/Auckland" },
        { value: "Pacific/Enderbury", label: "GMT+13 (+13) – Pacific/Enderbury" },
        { value: "Pacific/Fakaofo", label: "GMT+13 (+13) – Pacific/Fakaofo" },
        { value: "Pacific/Tongatapu", label: "GMT+13 (+13) – Pacific/Tongatapu" },
        { value: "Pacific/Chatham", label: "GMT+13:45 (+1345) – Pacific/Chatham" },
        { value: "Pacific/Apia", label: "GMT+14 (+14) – Pacific/Apia" },
        { value: "Pacific/Kiritimati", label: "GMT+14 (+14) – Pacific/Kiritimati"}
    ],

    states: [
        { value: "AL", label: "Alabama" },
        { value: "AK", label: "Alaska" },
        { value: "AZ", label: "Arizona" },
        { value: "AR", label: "Arkansas" },
        { value: "CA", label: "California" },
        { value: "CO", label: "Colorado" },
        { value: "CT", label: "Connecticut" },
        { value: "DE", label: "Delaware" },
        { value: "DC", label: "District of Columbia" },
        { value: "FL", label: "Florida" },
        { value: "GA", label: "Georgia" },
        { value: "HI", label: "Hawaii" },
        { value: "ID", label: "Idaho" },
        { value: "IL", label: "Illinois" },
        { value: "IN", label: "Indiana" },
        { value: "IA", label: "Iowa" },
        { value: "KS", label: "Kansas" },
        { value: "KY", label: "Kentucky" },
        { value: "LA", label: "Louisiana" },
        { value: "ME", label: "Maine" },
        { value: "MD", label: "Maryland" },
        { value: "MA", label: "Massachusetts" },
        { value: "MI", label: "Michigan" },
        { value: "MN", label: "Minnesota" },
        { value: "MS", label: "Mississippi" },
        { value: "MO", label: "Missouri" },
        { value: "MT", label: "Montana" },
        { value: "NE", label: "Nebraska" },
        { value: "NV", label: "Nevada" },
        { value: "NH", label: "New Hampshire" },
        { value: "NJ", label: "New Jersey" },
        { value: "NM", label: "New Mexico" },
        { value: "NY", label: "New York" },
        { value: "NC", label: "North Carolina" },
        { value: "ND", label: "North Dakota" },
        { value: "OH", label: "Ohio" },
        { value: "OK", label: "Oklahoma" },
        { value: "OR", label: "Oregon" },
        { value: "PA", label: "Pennsylvania" },
        { value: "RI", label: "Rhode Island" },
        { value: "SC", label: "South Carolina" },
        { value: "SD", label: "South Dakota" },
        { value: "TN", label: "Tennessee" },
        { value: "TX", label: "Texas" },
        { value: "UT", label: "Utah" },
        { value: "VT", label: "Vermont" },
        { value: "VA", label: "Virginia" },
        { value: "WA", label: "Washington" },
        { value: "WV", label: "West Virginia" },
        { value: "WI", label: "Wisconsin" },
        { value: "WY", label: "Wyoming" },
    ],

    provinces: [
        { value: "AB", label: "Alberta" },
        { value: "BC", label: "British Columbia" },
        { value: "MB", label: "Manitoba" },
        { value: "NB", label: "New Brunswick" },
        { value: "NL", label: "Newfoundland and Labrador" },
        { value: "NS", label: "Nova Scotia" },
        { value: "NT", label: "Northwest Territories" },
        { value: "NU", label: "Nunavut" },
        { value: "ON", label: "Ontario" },
        { value: "PE", label: "Prince Edward Isle" },
        { value: "QC", label: "Quebec" },
        { value: "SK", label: "Saskatchewan" },
        { value: "YT", label: "Yukon Territories" },
    ],

    auRegions: [
        { value: "ACT", label: "Australian Capital Territory" },
        { value: "NSW", label: "New South Wales" },
        { value: "NT", label: "Northern Territory" },
        { value: "QLD", label: "Queensland" },
        { value: "SA", label: "South Australia" },
        { value: "AS", label: "Tasmania" },
        { value: "VIC", label: "Victoria" },
        { value: "WA", label: "Western Australia" },
    ],

    cnRegions: [
        { value: "34", label: "Anhui" },
        { value: "11", label: "Beijing" },
        { value: "50", label: "Chongqing" },
        { value: "35", label: "Fujian" },
        { value: "62", label: "Gansu" },
        { value: "44", label: "Guangdong" },
        { value: "45", label: "Guangxi" },
        { value: "52", label: "Guizhou" },
        { value: "46", label: "Hainan" },
        { value: "13", label: "Hebei" },
        { value: "23", label: "Heilongjiang" },
        { value: "41", label: "Henan" },
        { value: "91", label: "Hong Kong" },
        { value: "42", label: "Hubei" },
        { value: "43", label: "Hunan" },
        { value: "32", label: "Jiangsu" },
        { value: "36", label: "Jiangxi" },
        { value: "22", label: "Jilin" },
        { value: "21", label: "Liaoning" },
        { value: "92", label: "Macao" },
        { value: "15", label: "Nei Mongol" },
        { value: "64", label: "Ningxia" },
        { value: "63", label: "Qinghai" },
        { value: "61", label: "Shaanxi" },
        { value: "37", label: "Shandong" },
        { value: "31", label: "Shanghai" },
        { value: "14", label: "Shanxi" },
        { value: "51", label: "Sichuan" },
        { value: "71", label: "Taiwan" },
        { value: "12", label: "Tianjin" },
        { value: "65", label: "Xinjiang" },
        { value: "54", label: "Xizang" },
        { value: "53", label: "Yunnan" },
        { value: "33", label: "Zhejiang" },
    ],

    ieRegions: [
        { value: "CW", label: "Carlow" },
        { value: "CN", label: "Cavan" },
        { value: "CE", label: "Clare" },
        { value: "CO", label: "Cork" },
        { value: "DL", label: "Donegal" },
        { value: "D", label: "Dublin" },
        { value: "G", label: "Galway" },
        { value: "KY", label: "Kerry" },
        { value: "KE", label: "Kildare" },
        { value: "KK", label: "Kilkenny" },
        { value: "LS", label: "Laois" },
        { value: "LM", label: "Leitrim" },
        { value: "LK", label: "Limerick" },
        { value: "LD", label: "Longford" },
        { value: "LH", label: "Louth" },
        { value: "MO", label: "Mayo" },
        { value: "MH", label: "Meath" },
        { value: "MN", label: "Monaghan" },
        { value: "OY", label: "Offaly" },
        { value: "RN", label: "Roscommon" },
        { value: "SO", label: "Sligo" },
        { value: "TA", label: "Tipperary" },
        { value: "WD", label: "Waterford" },
        { value: "WH", label: "Westmeath" },
        { value: "WX", label: "Wexford" },
        { value: "WW", label: "Wicklow" },
    ],

    inRegions: [
        { value: "AN", label: "Andaman and Nicobar Islands" },
        { value: "AP", label: "Andhra Pradesh" },
        { value: "AR", label: "Arunachal Pradesh" },
        { value: "AS", label: "Assam" },
        { value: "BR", label: "Bihar" },
        { value: "CH", label: "Chandigarh" },
        { value: "CT", label: "Chhattisgarh" },
        { value: "DN", label: "Dadra and Nagar Haveli" },
        { value: "DD", label: "Daman and Diu" },
        { value: "DL", label: "Delhi" },
        { value: "GA", label: "Goa" },
        { value: "GJ", label: "Gujarat" },
        { value: "HR", label: "Haryana" },
        { value: "HP", label: "Himachal Pradesh" },
        { value: "HY", label: "Hyderabad" },
        { value: "JK", label: "Jammu and Kashmir" },
        { value: "JH", label: "Jharkhand" },
        { value: "KA", label: "Karnataka" },
        { value: "KL", label: "Kerala" },
        { value: "LD", label: "Lakshadweep" },
        { value: "MP", label: "Madhya Pradesh" },
        { value: "MH", label: "Maharashtra" },
        { value: "MN", label: "Manipur" },
        { value: "ML", label: "Meghalaya" },
        { value: "MZ", label: "Mizoram" },
        { value: "NL", label: "Nagaland" },
        { value: "OR", label: "Odisha" },
        { value: "PY", label: "Puducherry" },
        { value: "PB", label: "Punjab" },
        { value: "RJ", label: "Rajasthan" },
        { value: "SK", label: "Sikkim" },
        { value: "TN", label: "Tamil Nadu" },
        { value: "TR", label: "Tripura" },
        { value: "UP", label: "Uttar Pradesh" },
        { value: "UT", label: "Uttarakhand" },
        { value: "WB", label: "West Bengal" },
    ],

};

